import { render, staticRenderFns } from "./HeaderProjectToggler.vue?vue&type=template&id=8db4753c&scoped=true&"
import script from "./HeaderProjectToggler.vue?vue&type=script&lang=js&"
export * from "./HeaderProjectToggler.vue?vue&type=script&lang=js&"
import style0 from "./HeaderProjectToggler.vue?vue&type=style&index=0&id=8db4753c&lang=css&"
import style1 from "./HeaderProjectToggler.vue?vue&type=style&index=1&id=8db4753c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db4753c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8db4753c')) {
      api.createRecord('8db4753c', component.options)
    } else {
      api.reload('8db4753c', component.options)
    }
    module.hot.accept("./HeaderProjectToggler.vue?vue&type=template&id=8db4753c&scoped=true&", function () {
      api.rerender('8db4753c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderProjectToggler.vue"
export default component.exports